import CompletionPopup from './CompletionPopup';
import CompletionPopupContainer from './CompletionPopup.container';
export default CompletionPopupContainer(CompletionPopup);

//# sourceMappingURL=index.js.map